import { useEffect, useState} from "react";
import { createContext, useReducer } from "react";




export const Authcontext = createContext() // for User


export const authreducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload }
        case 'LOGOUT':
            return { user: null,  expiryTime: null}
        default:
            return state;
    }
}



export const AuthContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(authreducer, {
        user: null,
        expiryTime: null
    })
    const [loading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        // Safely parse the user data
        const userData = localStorage.getItem('user');
        const sessionTime = localStorage.getItem('expiryTime');

        if (userData && sessionTime) {
            dispatch({ type: 'LOGIN', payload: userData,  });
        }
        setLoading(false); // Finish initialization
    }, [])

    //console.log('AuthContext State: ', state);

    return (
        <Authcontext.Provider value={{ ...state, dispatch, loading}}>
            {children}
        </Authcontext.Provider>
    )
}